<div class="col-md-6 offset-md-3 mt-5">
  <!-- <div class="alert alert-info">
  Username: test<br />
  Password: test
</div> -->
<div class="ng-container login-logo">
  <img src="splashscreen_logo.png">
</div>
<div class="card">
  <h4 class="card-header login-card">My Premises- Web Login</h4>
  <div class="card-body">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="username">Email</label>
        <input type="text" placeholder="Enter your email address" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['username'].errors }" />
        @if (submitted && f['username'].errors) {
          <div class="invalid-feedback">
            @if (f['username'].errors['required']) {
              <div>Username is required</div>
            }
          </div>
        }
      </div>
      <div class="form-group my-2">
        <label for="password">Password</label>
        <input type="password" placeholder="Enter your login password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" />
        @if (submitted && f['password'].errors) {
          <div class="invalid-feedback">
            @if (f['password'].errors['required']) {
              <div>Password is required</div>
            }
          </div>
        }
      </div>

      <button type="button" (click)="openRegistration()" class="btn btn-primary">
        Register <fa-icon [icon]="faUserPlus"></fa-icon>
      </button>

      <button id="loginbtn" [disabled]="loading" class="m-2 btn btn-success float-right">
        @if (loading) {
          <span class="spinner-border spinner-border-sm mr-1"></span>
        }
        Login  <fa-icon class="l-icon" [icon]="faSignInAlt"></fa-icon>
      </button>
      <div>
        <button (click)="openForgetPassword()" type="button" class="mt-1 btn btn-link">Forgot password?</button>
      </div>
      @if (pastLogin) {
        <div class="mt-4">
          <button  type="button" class="btn btn-warning" (click)="openQueryMaintenance()">Query fees <fa-icon class="l-icon" [icon]="faTachometerAlt"></fa-icon></button>
        </div>
      }
      @if (error) {
        <div class="alert alert-danger mt-3 mb-0">
          <div>{{error}}</div>
          @if (accountLocked) {
            <button
              type="button"
              class="btn btn-sm btn-light mt-2"
              [disabled]="unlockLoading"
              (click)="onUnlockAccount()"
            >
              @if (unlockLoading) {
                <span class="spinner-border spinner-border-sm mr-1"></span>
              }
              Unlock Account
            </button>
          }
        </div>
      }
    </form>
  </div>
</div>
</div>
